export enum StorageKeys {
  APPOINTMENT_SETUP = 'appointment-setup',
  AUTHENTICATION_RESULT = 'authentication-result',
  LANGUAGE = 'language',
  VERSION = 'version',
}
